import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { mountTable, unmountTable } from '@kineticdata/react';
import { regRoute, regSaga } from '../../store';
import { TrustedCertificatesList } from '../common/TrustedCertificatesList';

export const tableKey = 'system-setup-certs-table';

regRoute('SYSTEM_CERTS_PAGE', '/system/setup/infra/certs');

regSaga(
  takeEvery('ENTER_SYSTEM_CERTS_PAGE', function* () {
    yield call(mountTable, tableKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_CERTS_PAGE', function* () {
    yield call(unmountTable, tableKey);
  }),
);

export const SystemSetupTrustedCertificates = () => (
  <TrustedCertificatesList tableKey={tableKey} />
);
